import { ListRenderItem } from "@shopify/flash-list";
import { Fragment, memo, useRef } from "react";
import { View } from "react-native";
import useMountEffect from "src/hooks/useMountEffect";
import { StoreApi, useStore } from "zustand";
import { VirtualListStore } from "../stores/virtualListStore";

const VirtualRow = <T extends any>({
	rowKey,
	renderItem,
	rows,
	rowIndex,
	numColumns,
	store,
	remeasurementKey,
	isCellDefault,
}: {
	rowKey: string;
	renderItem: ListRenderItem<T> | undefined | null;
	rows: readonly T[];
	rowIndex: number;
	numColumns: number;
	store: StoreApi<VirtualListStore>;
	remeasurementKey: string | null;
	isCellDefault: boolean;
}) => {
	const isCell = useStore(store, (state) => {
		return state.isCellLookup[rowKey]?.isCell ?? isCellDefault;
	});

	const ref = useRef<View>(null);
	useMountEffect(() => {
		if (remeasurementKey) {
			ref.current?.measure((x, y, width, height, pageX, pageY) => {
				store.setState((state) => ({
					measurementLookup: {
						...state.measurementLookup,
						[rowKey]: {
							y: y,
							height: height,
						},
					},
				}));
			});
		}
	}, [remeasurementKey]);

	return (
		<View
			ref={ref}
			onLayout={(event) => {
				store.setState((state) => ({
					measurementLookup: {
						...state.measurementLookup,
						[rowKey]: {
							y: event.nativeEvent.layout.y,
							height: event.nativeEvent.layout.height,
						},
					},
				}));
			}}
			style={{
				flexDirection: "row",
			}}
		>
			{rows.map((item: T, i: number) => {
				return (
					<Fragment key={`${i}`}>
						{renderItem?.({
							item,
							index: rowIndex * numColumns + i,
							target: isCell ? "Cell" : "Measurement",
						})}
					</Fragment>
				);
			})}
		</View>
	);
};
export default memo(VirtualRow) as typeof VirtualRow;
